/* TBC quick add.

   Card: [data-tbc-qa] holds the button for its mode (add, cells, panel, page),
   a status line and the line item properties to write. Panel: one shell per
   page; its body is the alternate product view
   /products/<handle>?view=tbc-quick-add (templates/product.tbc-quick-add.liquid).

   Adds go straight to /cart/add.js so the properties are written even though
   the product page and its options app are skipped. */

(function () {
  var HOLD = 4000;
  var CLOSE_MS = 320;

  var panel = document.querySelector('[data-tbc-qa-panel]');
  var backdrop = document.querySelector('[data-tbc-qa-backdrop]');
  var body = panel && panel.querySelector('[data-tbc-qa-body]');
  var skeleton = panel && panel.querySelector('[data-tbc-qa-skeleton]');
  var live = document.querySelector('[data-tbc-qa-live]');
  var strings = readJSON(document.querySelector('[data-tbc-qa-strings]')) || {};

  var opener = null;
  var content = null;
  var variants = [];
  var selection = [];
  var busy = false;
  var token = 0;
  var closeTimer = null;
  var byKeyboard = false;

  document.addEventListener('keydown', function () { byKeyboard = true; }, true);
  document.addEventListener('pointerdown', function () { byKeyboard = false; }, true);

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function readJSON(node) {
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  }

  function announce(text) {
    if (!live) return;
    live.textContent = '';
    if (text) setTimeout(function () { live.textContent = text; }, 40);
  }

  /* ---- cart ------------------------------------------------------------ */

  function cartError(status, data) {
    var detail = (data && (data.description || data.message)) || '';
    var short = strings.error;
    if (status === 422 && /sold out|agotad/i.test(detail)) short = strings.sold_out;
    else if (status === 422 && /in your cart|en tu carrito|maximum|m\u00e1ximo/i.test(detail)) short = strings.max_in_cart;
    var error = new Error(short);
    error.detail = typeof detail === 'string' ? detail : '';
    return error;
  }

  function post(path, payload) {
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(
        function (data) {
          if (!response.ok) throw cartError(response.status, data);
          return data;
        },
        function () { throw cartError(response.status, null); }
      );
    }, function () {
      throw cartError(0, null);
    });
  }

  function addLine(variantId, properties) {
    var item = { id: Number(variantId), quantity: 1 };
    if (properties && Object.keys(properties).length) item.properties = properties;
    return post('cart/add.js', { items: [item] }).then(function (data) {
      return data.items[0];
    });
  }

  /* Reads the live quantity first: the line may have changed since the add.
     Its key too: marking a bundle piece (assets/tbc-bundles.js) rewrites its
     properties, so the same variant stands in when the key is gone. */
  function removeOne(line) {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var current = cart.items.filter(function (item) { return item.key === line.key; })[0] ||
          cart.items.filter(function (item) { return item.variant_id === line.variant_id; })[0];
        if (!current) return null;
        return post('cart/change.js', { id: current.key, quantity: Math.max(0, current.quantity - 1) });
      });
  }

  /* The theme opens the cart drawer every time the cart is rebuilt, and the
     gift app rebuilds it once more after adding its own lines. A quick add
     confirms on the card instead: the rebuild it asked for is swallowed, plus
     a short tail for the gift app. Any product form cancels the wait, so its
     own add still opens the drawer. */
  var expected = false;
  var tailUntil = 0;
  var expectTimer = null;

  window.addEventListener('theme:product:added', function (event) {
    if (expected) {
      expected = false;
      clearTimeout(expectTimer);
      tailUntil = Date.now() + 2500;
      event.stopImmediatePropagation();
    } else if (Date.now() < tailUntil) {
      event.stopImmediatePropagation();
    }
  }, true);

  function releaseDrawer() {
    expected = false;
    tailUntil = 0;
    clearTimeout(expectTimer);
  }

  document.addEventListener('submit', releaseDrawer, true);
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[data-add-to-cart]')) releaseDrawer();
  }, true);

  function refreshCart() {
    var items = document.querySelector('cart-items');
    if (items && typeof items.getCart === 'function') {
      expected = true;
      clearTimeout(expectTimer);
      expectTimer = setTimeout(function () { expected = false; }, 8000);
      items.getCart();
      return;
    }
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cartCount: cart.item_count } }));
      })
      .catch(function () {});
  }

  /* ---- card ------------------------------------------------------------ */

  function trigger(host) {
    return host.querySelector('.tbc-qa__hover[data-tbc-qa-add], .tbc-qa__hover[data-tbc-qa-open], .tbc-qa__cell[data-tbc-qa-add]');
  }

  function focusTrigger(host) {
    var target = trigger(host);
    var square = host.querySelector('.tbc-qa__square');
    if (square && square.offsetParent) target = square;
    if (!target) return;
    host.classList.add('is-returning');
    target.focus({ preventScroll: true });
  }

  function setStatus(host, state, options) {
    options = options || {};
    var hadFocus = byKeyboard && host.contains(document.activeElement);
    var prefix = host.querySelector('[data-tbc-qa-status-prefix]');
    var value = host.querySelector('[data-tbc-qa-status-value]');
    var status = host.querySelector('[data-tbc-qa-status]');

    if (prefix) prefix.textContent = options.text || '';
    if (value) value.textContent = options.value || '';
    if (status) {
      if (options.detail) status.setAttribute('title', options.detail); else status.removeAttribute('title');
    }
    if (options.value) host.setAttribute('data-has-value', ''); else host.removeAttribute('data-has-value');

    host.setAttribute('data-state', state);
    if (state === 'busy') host.setAttribute('aria-busy', 'true'); else host.removeAttribute('aria-busy');
    host._tbcLine = options.line || null;
    clearTimeout(host._tbcTimer);

    if (state === 'added' || state === 'removed' || state === 'error') {
      announce([options.text, options.value].filter(Boolean).join(' '));
      host._tbcTimer = setTimeout(function () { setStatus(host, 'rest'); }, state === 'removed' ? 1600 : HOLD);
    }

    if (state === 'added' && hadFocus) {
      var undoButton = host.querySelector('[data-tbc-qa-undo]');
      if (undoButton) undoButton.focus({ preventScroll: true });
    } else if (state === 'rest' && hadFocus) {
      focusTrigger(host);
    }
  }

  function confirmOn(host, line, value) {
    if (!host) return;
    setStatus(host, 'added', { text: strings.added, value: value, line: line });
  }

  /* A size cell under the price (snippets/tbc-card-sizes.liquid) works
     through its card's quick add, which shows the added / undo strip. */
  function hostOf(button) {
    var host = button.closest('[data-tbc-qa]');
    if (host) return host;
    var card = button.closest('[data-grid-item]');
    return card && card.querySelector('[data-tbc-qa]');
  }

  function addFromCard(button) {
    var host = hostOf(button);
    if (!host || host.getAttribute('data-state') === 'busy') return;
    var sizes = button.closest('[data-tbc-sizes]');
    var properties = readJSON((sizes && sizes.querySelector('[data-tbc-sizes-props]')) || host.querySelector('[data-tbc-qa-props]')) || {};
    var value = button.getAttribute('data-value') || '';

    setStatus(host, 'busy');
    addLine(button.getAttribute('data-variant-id'), properties)
      .then(function (line) {
        confirmOn(host, line, value);
        refreshCart();
      })
      .catch(function (error) {
        setStatus(host, 'error', { text: error.message, detail: error.detail });
      });
  }

  function undo(button) {
    var host = button.closest('[data-tbc-qa]');
    if (!host || !host._tbcLine) return;
    var line = host._tbcLine;
    setStatus(host, 'busy');
    removeOne(line)
      .then(function () {
        setStatus(host, 'removed', { text: strings.removed });
        refreshCart();
      })
      .catch(function (error) {
        setStatus(host, 'error', { text: error.message, detail: error.detail });
      });
  }

  function setCellLabel(cell, active) {
    var host = cell.closest('[data-tbc-qa]');
    var label = host && host.querySelector('[data-tbc-qa-label]');
    if (!label) return;
    label.textContent = active ? cell.getAttribute('data-label') : label.getAttribute('data-rest');
  }

  /* ---- panel ----------------------------------------------------------- */

  function setInert(on) {
    Array.prototype.forEach.call(document.body.children, function (node) {
      if (node === panel || node === backdrop || node === live) return;
      if (on) {
        if (!node.hasAttribute('inert')) { node.setAttribute('inert', ''); node.setAttribute('data-tbc-qa-inert', ''); }
      } else if (node.hasAttribute('data-tbc-qa-inert')) {
        node.removeAttribute('inert');
        node.removeAttribute('data-tbc-qa-inert');
      }
    });
  }

  function openPanel(button) {
    var host = hostOf(button);
    if (!panel || !host) return;
    clearTimeout(closeTimer);
    opener = button;
    busy = false;
    panel.hidden = false;
    backdrop.hidden = false;
    panel.getBoundingClientRect();
    document.documentElement.classList.add('tbc-qa-open');
    setInert(true);
    panel.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('theme:quick-add:open', { bubbles: true }));
    load(host.getAttribute('data-handle'), false);
  }

  function closePanel() {
    if (!panel || panel.hidden) return;
    token += 1;
    document.documentElement.classList.remove('tbc-qa-open');
    setInert(false);
    var target = opener;
    opener = null;
    content = null;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      panel.hidden = true;
      backdrop.hidden = true;
      body.textContent = '';
      body.removeAttribute('aria-busy');
      busy = false;
    }, CLOSE_MS);

    if (target && document.contains(target)) {
      /* The button is hidden until its card is hovered or holds focus. */
      var host = target.closest('[data-tbc-qa]');
      if (host && byKeyboard) host.classList.add('is-returning');
      target.focus({ preventScroll: true });
      if (document.activeElement !== target && host) {
        var fallback = host.querySelector('[data-tbc-qa-undo]');
        if (fallback) fallback.focus({ preventScroll: true });
      }
    }
  }

  function load(handle, fromSibling) {
    var mine = ++token;
    body.setAttribute('aria-busy', 'true');
    /* Opening: the panel takes its full shape at once, a skeleton in place of
       the product. Switching siblings keeps the product shown, dimmed. */
    if (!content && skeleton) body.replaceChildren(skeleton.content.cloneNode(true));
    return fetch(root() + 'products/' + handle + '?view=tbc-quick-add')
      .then(function (response) {
        if (!response.ok) throw new Error(strings.error);
        return response.text();
      })
      .then(function (html) {
        if (mine !== token) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-tbc-qa-content]');
        if (!next) throw new Error(strings.error);
        body.replaceChildren(document.importNode(next, true));
        content = body.querySelector('[data-tbc-qa-content]');
        start();
        body.removeAttribute('aria-busy');
        var focus = fromSibling
          ? content.querySelector('[data-tbc-qa-sibling][aria-pressed="true"]')
          : content.querySelector('.tbc-qa-chip:not([aria-disabled="true"])') || content.querySelector('[data-tbc-qa-submit]');
        (focus || panel).focus({ preventScroll: true });
      })
      .catch(function () {
        if (mine !== token) return;
        body.removeAttribute('aria-busy');
        if (!content) closePanel();
      });
  }

  function start() {
    variants = readJSON(content.querySelector('[data-tbc-qa-variants]')) || [];
    var groups = content.querySelectorAll('[data-tbc-qa-option]');
    selection = Array.prototype.map.call(groups, function () { return null; });

    var available = variants.filter(function (variant) { return variant.available; });
    if (available.length === 1) selection = available[0].options.slice(0, selection.length);

    render();
  }

  function chosenVariant() {
    if (selection.indexOf(null) !== -1) return null;
    return variants.filter(function (variant) {
      return selection.every(function (value, index) { return variant.options[index] === value; });
    })[0] || null;
  }

  function valueAvailable(index, value) {
    return variants.some(function (variant) {
      if (!variant.available || variant.options[index] !== value) return false;
      return selection.every(function (chosen, other) {
        return other === index || chosen === null || variant.options[other] === chosen;
      });
    });
  }

  function render() {
    Array.prototype.forEach.call(content.querySelectorAll('[data-tbc-qa-option]'), function (group) {
      var index = Number(group.getAttribute('data-tbc-qa-option'));
      Array.prototype.forEach.call(group.querySelectorAll('[data-tbc-qa-value]'), function (chip) {
        var value = chip.getAttribute('data-tbc-qa-value');
        var ok = valueAvailable(index, value);
        chip.classList.toggle('tbc-qa-chip--out', !ok);
        if (ok) {
          chip.removeAttribute('aria-disabled');
          chip.removeAttribute('aria-label');
        } else {
          chip.setAttribute('aria-disabled', 'true');
          chip.setAttribute('aria-label', (strings.sold_out_value || '').replace('__VALUE__', value));
        }
        chip.setAttribute('aria-pressed', ok && selection[index] === value ? 'true' : 'false');
      });
    });

    var variant = chosenVariant();
    var shown = variant || variants.filter(function (item) { return item.available; })[0] || variants[0];
    var price = content.querySelector('[data-tbc-qa-price]');
    if (price && shown) {
      price.classList.toggle('tbc-qa-price--sale', Boolean(shown.compare));
      price.textContent = '';
      var now = document.createElement('span');
      now.className = 'tbc-qa-price__now';
      now.textContent = shown.price;
      price.appendChild(now);
      if (shown.compare) {
        var was = document.createElement('s');
        was.className = 'tbc-qa-price__was';
        was.textContent = shown.compare;
        price.appendChild(was);
      }
    }

    var submit = content.querySelector('[data-tbc-qa-submit]');
    var ready = Boolean(variant && variant.available);
    if (ready) submit.removeAttribute('aria-disabled'); else submit.setAttribute('aria-disabled', 'true');
    submit.textContent = submit.getAttribute(ready ? 'data-label-add' : 'data-label-select');

    var error = content.querySelector('[data-tbc-qa-error]');
    if (error) error.hidden = true;
  }

  function submitPanel(button) {
    if (busy || !content || button.getAttribute('aria-disabled') === 'true') return;
    var variant = chosenVariant();
    if (!variant) return;
    var properties = readJSON(content.querySelector('[data-tbc-qa-props]')) || {};
    var host = opener && opener.closest('[data-tbc-qa]');
    var value = variants.length > 1 ? variant.title : '';
    var mine = token;

    busy = true;
    button.setAttribute('aria-busy', 'true');
    addLine(variant.id, properties)
      .then(function (line) {
        refreshCart();
        if (mine !== token) { busy = false; confirmOn(host, line, value); return; }
        button.removeAttribute('aria-busy');
        button.textContent = button.getAttribute('data-label-added');
        setTimeout(function () {
          /* Status first: closing then sends focus to Undo, since the button it came from is replaced. */
          confirmOn(host, line, value);
          if (mine === token) closePanel();
        }, 700);
      })
      .catch(function (error) {
        busy = false;
        if (mine !== token || !content) return;
        button.removeAttribute('aria-busy');
        var message = content.querySelector('[data-tbc-qa-error]');
        if (message) {
          message.textContent = error.detail || error.message;
          message.hidden = false;
        }
      });
  }

  function trapFocus(event) {
    var nodes = panel.querySelectorAll('a[href], button:not([disabled])');
    if (!nodes.length) { event.preventDefault(); panel.focus(); return; }
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    var active = document.activeElement;
    var outside = !panel.contains(active) || active === panel;
    if (event.shiftKey && (active === first || outside)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || outside)) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ---- events ---------------------------------------------------------- */

  /* Capture phase, and the event stops here: something else on the card
     follows the product link on any click inside it. */
  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-tbc-qa-add], [data-tbc-qa-open], [data-tbc-qa-undo], [data-tbc-qa-close], [data-tbc-qa-backdrop], [data-tbc-qa-sibling], [data-tbc-qa-value], [data-tbc-qa-submit], .tbc-qa__cell--out');
    if (!target) {
      if (event.target.closest('[data-tbc-qa-status], .tbc-qa__picker')) event.stopPropagation();
      return;
    }
    event.stopPropagation();

    if (target.matches('.tbc-qa__cell--out')) { event.preventDefault(); return; }
    if (target.matches('[data-tbc-qa-add]')) { event.preventDefault(); addFromCard(target); return; }
    if (target.matches('[data-tbc-qa-open]')) { event.preventDefault(); openPanel(target); return; }
    if (target.matches('[data-tbc-qa-undo]')) { event.preventDefault(); undo(target); return; }
    if (target.matches('[data-tbc-qa-close], [data-tbc-qa-backdrop]')) { closePanel(); return; }
    if (target.matches('[data-tbc-qa-submit]')) { submitPanel(target); return; }

    if (target.getAttribute('aria-disabled') === 'true' || !content) return;

    if (target.matches('[data-tbc-qa-sibling]')) {
      if (target.getAttribute('aria-pressed') !== 'true') load(target.getAttribute('data-tbc-qa-sibling'), true);
      return;
    }

    if (target.matches('[data-tbc-qa-value]')) {
      var index = Number(target.closest('[data-tbc-qa-option]').getAttribute('data-tbc-qa-option'));
      selection[index] = target.getAttribute('data-tbc-qa-value');
      render();
    }
  }, true);

  ['mouseover', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var cell = event.target.closest && event.target.closest('.tbc-qa__cell[data-label]');
      if (cell) setCellLabel(cell, true);
    });
  });

  ['mouseout', 'focusout'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var cell = event.target.closest && event.target.closest('.tbc-qa__cell[data-label]');
      if (cell) setCellLabel(cell, false);
    });
  });

  document.addEventListener('focusout', function (event) {
    var host = event.target.closest && event.target.closest('.tbc-qa.is-returning');
    if (host && !host.contains(event.relatedTarget)) host.classList.remove('is-returning');
  });

  document.addEventListener('keydown', function (event) {
    if (!panel || panel.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); closePanel(); }
    if (event.key === 'Tab') trapFocus(event);
  });
})();
